import { matchingFlags } from "../../context/featureFlags/featureFlagsContext";
import appConfig from "../../feature.config";
import tenantConfig from "../../tenant.config";
import { getMatchingRoute } from "../helper/getMatchingRoute";
import {
  COUNTRY_FLAGGED_PAGES,
  FEATURE_FLAGGED_PAGES,
} from "./featureFlags.constant";

/*
 * This function checks if the feature flagged page is allowed to be displayed.
 * A feature flagged page is allowed to be displayed if
 * - one of the feature flags is active, and one of country is allowed (if country flags are present)
 */
export const isFeatureFlagPageAllowed = (
  pathname: string,
  country?: string
) => {
  const route = getMatchingRoute(pathname, Object.keys(FEATURE_FLAGGED_PAGES));
  const featureFlags = FEATURE_FLAGGED_PAGES[route];
  const countryFlags = COUNTRY_FLAGGED_PAGES[route];
  if (!featureFlags) {
    console.warn(
      `[MIDDLEWARE] No feature flags found for this page ${pathname}.`
    );
    // return false by default if the feature flagged page has no feature flags
    return false;
  }
  if (!countryFlags) return featureFlags.some((flag) => flag);
  return (
    featureFlags.some((flag) => flag) && countryFlags.includes(country || "")
  );
};

export function isProd() {
  const ENVIRONMENT_NAME = process.env.NEXT_PUBLIC_ENVIRONMENT_NAME ?? "";
  // Stable stages: Alta main/pre-main, or any tenant-{id}-{main|pre-main} namespace
  return (
    ENVIRONMENT_NAME === "main" ||
    ENVIRONMENT_NAME === "pre-main" ||
    (ENVIRONMENT_NAME.startsWith("tenant-") &&
      (ENVIRONMENT_NAME.endsWith("-main") ||
        ENVIRONMENT_NAME.endsWith("-pre-main")))
  );
}

export function featureFlag(feature: keyof typeof appConfig) {
  const tenantMap = {
    ...tenantConfig.services["a-prime"].features,
    ...tenantConfig.services["a-prime"].integrations,
  } as Record<string, { enabled?: boolean } | undefined>;
  const tenantEntry = tenantMap[feature];

  const stageEnabled = isProd()
    ? !!appConfig[feature]?.prod
    : !!appConfig[feature]?.dev;

  if (!stageEnabled) return false;

  // Pack/runtime tenant config wins when the key is defined (AG-7282: staging must respect mmf.enabled)
  if (tenantEntry && typeof tenantEntry.enabled === "boolean") {
    return tenantEntry.enabled;
  }

  // Prod: missing tenant key stays off. Non-prod: fall back to stage default.
  return isProd() ? false : true;
}
